import {Box, IconButton} from '@mui/material';
import {Field, FieldArray, Form, useFormikContext} from 'formik';
import {ReactComponent as CloseIcon} from '@/assets/icons/close_big.svg';
import {OUTLINED} from '@/utils/constants';
import {ReactComponent as PlusIcon} from '@/assets/icons/plus.svg';
import {AddWinnerStyles} from '@/pages/Organization/AddWinnerPage/AddWinnerStyle.styles';
import {FormValuesWinners} from '@/pages/Organization/AddWinnerPage';
import Button from '@/shared/components/Button';
import Input from '@/shared/components/Inputs/Input';
import AddWinnerActions from '../AddWinerActions';

const AddWinnerForm = () => {
	const {values} = useFormikContext<FormValuesWinners>();

	return (
		<Box>
			<Form>
				<FieldArray name="winners">
					{({push, remove}) => (
						<Box sx={AddWinnerStyles.list}>
							{values.winners.map((winner, index) => (
								<Box key={index} sx={AddWinnerStyles.row}>
									<Field
										id={`winners.${index}.itemNumber`}
										name={`winners.${index}.itemNumber`}
										component={Input}
										label="Item Number"
										placeholder="Enter item number"
										isArrayData
									/>

									<Field
										name={`winners.${index}.bidderNumber`}
										component={Input}
										label="Winning Bidder Number"
										placeholder="Enter winning bidder number"
										isArrayData
									/>

									<Field
										name={`winners.${index}.bidAmount`}
										component={Input}
										label="Winning Bid Amount"
										placeholder="Enter winning bid amount"
										isArrayData
									/>

									{index !== 0 && (
										<IconButton sx={AddWinnerStyles.removeBtn} onClick={() => remove(index)}>
											<CloseIcon />
										</IconButton>
									)}
								</Box>
							))}
							<Box sx={AddWinnerStyles.addButtonWrapper}>
								<Button
									sx={AddWinnerStyles.addBtn}
									variant={OUTLINED}
									startIcon={<PlusIcon />}
									title="Add Winner"
									onClick={() =>
										push({
											itemNumber: '',
											bidderNumber: '',
											bidAmount: '',
										})
									}
								/>
							</Box>
						</Box>
					)}
				</FieldArray>
				<AddWinnerActions />
			</Form>
		</Box>
	);
};

export default AddWinnerForm;
